import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { FootersPage, FootersPagedData, IActivityLogs, IFooterCloneModel, IFooterModel, IFootersForDropdown, IFootersModel } from './footers.model';

@Injectable()
export class FootersService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'footers';

    /** GET */
    public getFooter(id: string): Observable<SuccessResponse<IFooterModel> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IFooterModel>>(
                FootersService.URL +
                FootersService.ENDPOINT + '/' + id,
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getFootersForDropdown(): Observable<SuccessResponse<IFootersForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IFootersForDropdown>>(
                FootersService.URL +
                FootersService.ENDPOINT + '/dropdowns',
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** PUT */
    public updateFooter(data: IFooterModel): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .put<SuccessResponse<boolean>>(
                FootersService.URL +
                FootersService.ENDPOINT + '/' + data?.id,
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

     /** POST */
     public addFooter(data: IFooterModel): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<boolean>>(
                FootersService.URL +
                FootersService.ENDPOINT,
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public cloneFooter(data: IFooterCloneModel): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<boolean>>(
                FootersService.URL +
                FootersService.ENDPOINT + '/' + data?.id + '/clones',
                data
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getFooters(page: FootersPage): Observable<SuccessResponse<FootersPagedData<IFootersModel>> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<FootersPagedData<IFootersModel>>>(
                FootersService.URL +
                FootersService.ENDPOINT + '/filters',
                page
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** DELETE */
    public deleteFooter(id: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .delete<SuccessResponse<boolean>>(
                FootersService.URL +
                FootersService.ENDPOINT + '/' + id,
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getActivityLogs(): Observable<SuccessResponse<IActivityLogs> | ErrorResponse> {
        return this.http
        .post<SuccessResponse<IActivityLogs>>(
            FootersService.URL  +
            FootersService.ENDPOINT +
            '/activities', {})
        .pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
